import { render, staticRenderFns } from "./detailsPickingListRecord.vue?vue&type=template&id=33c995ea&scoped=true"
import script from "./detailsPickingListRecord.vue?vue&type=script&lang=js"
export * from "./detailsPickingListRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsPickingListRecord.vue?vue&type=style&index=0&id=33c995ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c995ea",
  null
  
)

export default component.exports